var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBookCycle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon book cycle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 41",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 29",
    d: "M15.652 9.183a4.163 4.163 0 0 1 1.318-3.045l-1.243-1.923-2.99 4.148h1.691a.521.521 0 0 1 .513.425 2.331 2.331 0 0 1-.462 1.871 2.074 2.074 0 0 1-1.621.628c-.1 0-.2 0-.31-.013a.522.522 0 0 1 .085-1.041 1.258 1.258 0 0 0 1.067-.272.986.986 0 0 0 .219-.555H8.342a4.172 4.172 0 1 1-2.39-4l1.66-2.393-.55-.88h-.638a.522.522 0 0 1 0-1.043h3.221a.522.522 0 0 1 0 1.043H8.292l.3.488h6.024L13.283.835A.522.522 0 0 1 13.7 0h3.24a.522.522 0 0 1 0 1.043h-2.2l1.342 1.787a.52.52 0 0 1 .066.117l1.667 2.577a4.174 4.174 0 1 1-2.163 3.659zm1.043 0a3.132 3.132 0 1 0 1.69-2.783l1.421 2.2a.522.522 0 1 1-.876.567l-1.38-2.132a3.121 3.121 0 0 0-.85 2.148zm-15.652 0a3.131 3.131 0 0 0 6.257.223H4.173a.521.521 0 0 1-.428-.819l1.6-2.308a3.13 3.13 0 0 0-4.3 2.9zm9.909-.82L8.213 3.976l-1.38 1.99a4.171 4.171 0 0 1 1.434 2.4zm-5.781 0H7.2a3.137 3.137 0 0 0-.961-1.535zm6.672-.544 3-4.156H9.248z",
    transform: "translate(0 5.322)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookCycle);
export default __webpack_public_path__ + "static/media/iconBookCycle.b0e80440b5d23dec7a90723d1a721eaf.svg";
export { ForwardRef as ReactComponent };